import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

export default function SignUpPage() {
  const [formData, setFormData] = useState({
    firstname: "", // Utilisé pour construire username
    lastname: "",  // Utilisé pour construire username
    email: "",
    password: "",
    confirmPassword: ""
  });
  
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError(""); 
  };

  const validateForm = () => {
    // Restriction Email : format valide
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError("Format d'email invalide.");
      return false;
    }

    // Restriction Mot de passe : min 6 caractères (ajustable)
    if (formData.password.length < 6) {
      setError("Le mot de passe doit faire au moins 6 caractères.");
      return false;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      // ADAPTATION AU MODÈLE MONGOOSE :
      // On transforme "John" et "Doe" en "John Doe" pour le champ username
      const dataToSend = {
        username: `${formData.firstname} ${formData.lastname}`.trim(),
        email: formData.email,
        password: formData.password,
        role: "user" // Défini explicitement ici par sécurité
      };

      await axios.post("https://api.memofacdz.com/api/auth/register", dataToSend);

      alert("Inscription réussie !");
      navigate("/login");
      
    } catch (err) {
      // Gestion des erreurs d'unicité (email déjà pris par exemple)
      setError(err.response?.data?.message || "Erreur lors de l'inscription");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-card glass-card">
        <h2>Créer un compte</h2>
        
        <form onSubmit={handleSubmit} className="login-form">
          {/* Champs Nom/Prénom qui deviendront 'username' */}
          <div style={{ display: 'flex', gap: '10px' }}>
            <input 
              type="text" 
              name="firstname" 
              placeholder="Prénom" 
              onChange={handleChange} 
              required 
            />
            <input 
              type="text" 
              name="lastname" 
              placeholder="Nom" 
              onChange={handleChange} 
              required 
            />
          </div>

          <input 
            type="email" 
            name="email" 
            placeholder="Email" 
            onChange={handleChange} 
            required 
          />

          <input 
            type="password" 
            name="password" 
            placeholder="Mot de passe" 
            onChange={handleChange} 
            required 
          />

          <input 
            type="password" 
            name="confirmPassword" 
            placeholder="Confirmer mot de passe" 
            onChange={handleChange} 
            required 
          />

          {error && <p className="error-message" style={{color: 'red'}}>{error}</p>}

          <button type="submit" className="login-button-submit" disabled={loading}>
            {loading ? "Chargement..." : "S'inscrire"}
          </button>
        </form>
      </div>
    </div>
  );
}